export default __webpack_public_path__ + "static/flask-icon-c063834edbc3cda45091c79b1c19e5fe.svg";